export const MaxPaletteColorCount = 4 * 5 * 6
